/**
 * 在 Chart 中查找特定 id 的子 View
 * @param chart
 * @param id
 */
export function findViewById(chart, id) {
  return chart.views.find(function (view) {
    return view.id === id;
  });
}